import { Reducer } from 'redux';

import { LogsActionTypesEnum, LogsState, NotificationLogsTypes } from './types';
import { DeliveryLogType } from '@dev/ee-api/ee-api-models';

const defaultState = {
    inProgressActivePage: 1,
    inProgressLogPage: 1,
    inProgressLoading: false,
    inProgressDelayedLoading: false,
    inProgressDelayedLoopId: '',
    setLoader: false,
    logLoading: false,
    statusesInProgress: [DeliveryLogType.ReadyToSend, DeliveryLogType.WaitingToRetry, DeliveryLogType.Sending],
    hasMoreLogs: true,
};

const reducer: Reducer<LogsState> = (state: LogsState = defaultState, action): LogsState => {
    const { payload, type } = action;
    switch (type) {
        case LogsActionTypesEnum.UPDATE_EVENT_COUNTS:
            return {
                ...state,
                eventsCounts: payload,
                countsLoading: false,
            };
        case LogsActionTypesEnum.FETCH_EVENTS_COUNTS:
            return {
                ...state,
                countsLoading: true,
            };
        case '@@logs/LOAD_LOG_START':
        case '@@logs/LOAD_LOG_ERROR':
        case '@@logs/LOAD_LOG_SUCCESS':
        case NotificationLogsTypes.LOAD:
        case NotificationLogsTypes.SUCCESS:
        case '@@logs/LOAD_IN_PROGRESS_STATS_START':
        case '@@logs/LOAD_IN_PROGRESS_STATS_SUCCESS':
        case '@@logs/LOAD_IN_PROGRESS_STATS_ERROR':
        case '@@logs/LOAD_IN_PROGRESS_STATS_DELAYED_START':
        case '@@logs/LOAD_IN_PROGRESS_STATS_DELAYED_SUCCESS':
        case '@@logs/LOAD_IN_PROGRESS_STATS_DELAYED_ERROR':
        case '@@logs/SET_INPROGRESS_LOADER':
        case '@@logs/CANCEL_IN_PROGRESS_START':
        case '@@logs/CANCEL_IN_PROGRESS_SUCCESS':
        case '@@logs/CANCEL_IN_PROGRESS_ERROR':
        case '@@logs/RESEND_START':
            return {
                ...state,
                ...payload,
            };
        case '@@logs/CLEAR_LOG_LIST':
            return {
                ...state,
                logList: null,
            };
        case '@@logs/EXPORT_LOG':
        case '@@logs/EXPORT_LOG_START':
        case '@@logs/EXPORT_LOG_SUCCESS':
        case '@@logs/EXPORT_LOG_ERROR':
        case '@@logs/RESEND_SUCCESS':
        case '@@logs/RESEND_ERROR':
        default:
            return state;
    }
};

export { reducer as logs };

export default reducer;
